export default "__VITE_ASSET__BZvvVplN__"